import Pagination from 'shared-assets/components/Pagination';

angular
  .module('kareo.ui.shared.directives.k-pagination', [
    'react'
  ])
  .directive('kPagination', kPagination);

function kPagination(reactDirective) {
    return reactDirective(Pagination);
}

kPagination.$inject = ['reactDirective'];
